var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5Cd2Fcbe434701B73B7499C181E0E9947A7730Ce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 273.745 219.223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 63",
    d: "M0 17.038C0 7.6282 7.62819 0 17.038 0H256.707C266.116 0 273.745 7.62819 273.745 17.038V219.223H0V17.038Z",
    fill: "var(--fill-0, #002E2A)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5Cd2Fcbe434701B73B7499C181E0E9947A7730Ce);
export default __webpack_public_path__ + "static/media/5cd2fcbe434701b73b7499c181e0e9947a7730ce.097c74c733008d92fa40386821dbfb53.svg";
export { ForwardRef as ReactComponent };